import axios from 'axios';
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import * as headerBlock from '../header/';
import Autocomplete from '../autocomplete/vue-autocomplete.vue';
import AreaCheckbox from '../areaCheckbox/';
import Thumbnail from '../thumbnail';
import Uploading from '../uploading';

const alert = require('vue-strap').alert;
const spinner = require('vue-strap').spinner;

export default {
  name: 'audit-config',
  components: {
    headerBlock,
    Autocomplete,
    AreaCheckbox,
    alert,
    spinner,
    Thumbnail,
    Uploading,
    Multiselect },
  props: [
    'onLogout',
    'access_token',
    'authUser',
    'duplicate',
  ],
  mounted() {

  },
  data() {
    return {
      formData: {
        id: null,
        name: '',
        picture: '',
        picture_url: '',
        role: 'basic',
        area: [],
        signatureCount: 0,
        score_type: 'thumbs',
        lowScore: 1,
        highScore: 10,
        tasks: [],
      },
      is_performed: false,
      signatureCountOptions: [{
        text: 'No',
        value: 0,
      }, {
        text: 'Yes, one signature',
        value: 1,
      }, {
        text: 'Yes, two signatures',
        value: 2,
      }],
      scoreTypeOptions: [{
        text: 'Thumb up/down',
        value: 'thumbs',
      }, {
        text: 'Custom score',
        value: 'score',
      }],
      activeTask: null,
      activeTaskNext: null,
      showTasks: true,
      tagsOptions: [],
      emptyTask: {
        id: null,
        name: '',
        description: '',
        selectedContent: '',
        picture: '',
        picture_url: '',
        video: '',
        video_url: '',
        video_thumbnail: '',
        thumbnail_url: null,
        video_require: false,
        description_file: '',
        description_file_url: '',
        steps: [],
        stepsMustDelete: [],
        index: 0,
        weight: null,
        tags: '',
        tagsValue: [],
      },
      emptyStep: {
        id: null,
        order: 1,
        description: '',
        valid: true,
        picture_urlChanged: false,
        selectedContent: '',
        picture: '',
        picture_url: '',
        video: '',
        video_url: '',
        video_thumbnail: '',
        thumbnail_url: null,
        video_require: false,
      },
      suggestArea: [],
      userRoles: [],
      areas: [],
      audit: null,
      auditId: null,
      processLoading: false,
      areaFromList: false,
      breadCrumbItems: [
        {
          text: 'Home',
          to: `${process.env.START_URL}/`,
        }, {
          text: 'Audits',
          to: `${process.env.START_URL}/constructor/Audits`,
        }, {
          text: 'Constructor',
          active: true,
        },
      ],
      haveItemChanges: false,
      needFill: false,
      hasSaveError: false,
      alertError: {
        text: 'Some fields are not filled',
        title: 'Error!',
        visible: false,
      },
      alertSuccess: {
        text: 'Saved successfully',
        title: 'Well Done!',
        visible: false,
      },
      upload: {
        total: 1,
        uploaded: 0,
        image: true,
        visible: false,
      },
      dragSrcEl: null,
    };
  },
  methods: {
    handleVideoFileChange(e) {
      if (e.target.files && e.target.files[0] && e.target.files[0].size > 50000000) {
        e.target.value = '';
        this.alertError.text = 'Maximum allowed video size is 50 MB.';
        this.alertError.visible = true;
        return;
      }
    },
    updateTags(task) {
      task.tags = '';
      for (let i = 0; i < task.tagsValue.length; i++) {
        if (i !== 0) {
          task.tags = `${task.tags}, `;
        }
        task.tags = `${task.tags}${task.tagsValue[i].name}`;
      }
      this.onChangeAuditTask();
    },
    addTag(task, newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
      };
      if (!this.tagsOptions.some((item) => {
        if (item.name === tag.name) {
          tag.code = item.code;
          return true;
        }
        return false;
      })) {
        this.tagsOptions.push(tag);
      }
      task.tagsValue.push(tag);
      this.updateTags(task);
    },
    addEmptyStep(task) {
      let maxStepOrder = 0;
      const self = this;
      const orders = [];
      let orderCount = 1;
      for (let i = 0; i < task.steps.length; i++) {
        orders.push(+task.steps[i].order);
        if (maxStepOrder < task.steps[i].order) {
          maxStepOrder = task.steps[i].order;
        }
      }
      for (let i = 1; i <= +maxStepOrder + 1; i++) {
        if (orders.indexOf(i) === -1) {
          orderCount = i;
          break;
        }
      }
      task.steps.push(JSON.parse(JSON.stringify(self.emptyStep)));
      task.steps[task.steps.length - 1].order = orderCount;
    },
    addEmptyTask() {
      this.formData.tasks.push(JSON.parse(JSON.stringify(this.emptyTask)));
      // this.addEmptyStep(this.formData.tasks[this.formData.tasks.length - 1]);
      console.log('add task', this.formData.tasks);
      if (this.activeTask === null) {
        this.activeTask = 0;
      }
    },
    removeStep(task, index) {
      if (task.steps[index].id) {
        task.stepsMustDelete.push(task.steps[index].id);
      }
      task.steps.splice(index, 1);
    },
    processJSON(json) {
      return json.results;
    },
    getDataSearchArea(data, area) {
      this.formData.area = [area.area];
    },
    getUserAreaPath(area) {
      const result = [];
      for (let i = 0; i < area.length; i++) {
        const res = this.getUserAreaPath(area[i].subareas);
        for (let j = 0; j < res.length; j++) {
          result.push({ name: `${area[i].name}/${res[j].name}`, area: res[j].area });
        }
        if (res.length === 0) {
          result.push({ name: area[i].name, area: area[i] });
        }
      }
      return result;
    },
    updateSuggestArea() {
      this.suggestArea = [];
      const areaPaths = this.getUserAreaPath(this.areas);
      for (let i = 0; i < areaPaths.length; i++) {
        this.suggestArea.push(areaPaths[i]);
      }
    },
    clearAuditItemVideo(e, step, index) {
      console.log(this.$refs.auditItemVideoFile, index);
      if (step.video_url) {
        step.video_url = '';
        this.$refs.auditItemVideoFile[index].reset();
        e.preventDefault();
        return;
      }
      if (!step.video) {
        return;
      }
      this.$refs.auditItemVideoFile[index].reset();
      e.preventDefault();
    },
    clearStepVideo(e, step, index) {
      console.log(this.$refs.stepvideofile, index);
      if (step.video_url) {
        step.video_url = '';
        this.$refs.stepvideofile[index].reset();
        e.preventDefault();
        return;
      }
      if (!step.video) {
        return;
      }
      this.$refs.stepvideofile[index].reset();
      e.preventDefault();
    },
    clearPdfFile(e, index) {
      if (this.formData.tasks[index].description_file_url) {
        this.formData.tasks[index].description_file_url = '';
        this.$refs[`pdffile${index}`][0].reset();
        e.preventDefault();
        return;
      }
      if (!this.formData.tasks[index].description_file) {
        return;
      }
      this.$refs[`pdffile${index}`][0].reset();
      e.preventDefault();
    },
    changePdfFile(e, index) {
      if (!this.formData.tasks[index].description_file) {
        return null;
      }
      if (this.formData.tasks[index].description_file &&
          this.formData.tasks[index].description_file.size > 5000000) {
        this.$refs[`pdffile${index}`][0].reset();
        this.alertError.text = 'Maximum allowed file size is 5 MB.';
        this.alertError.visible = true;
      }
      return null;
    },
    calculateImagesCount() {
      let result = 0;
      if (this.formData.picture) {
        console.log('this.formData.picture');
        result++;
      }
      for (let i = 0; i < this.formData.tasks.length; i++) {
        if (this.formData.tasks[i].picture) result++;
        if (this.formData.tasks[i].description_file) result++;
        result += this.formData.tasks[i].steps.filter(item => item.picture).length;
      }
      console.log('calculateImagesCount', result);
      return result;
    },
    uploadVideo(data) {
      const uploadData = {
        filename: data.name,
      }
      if (this.$route.params.companyId) {
        uploadData.company = this.$route.params.companyId;
      }
      return this.$http.post('upload/', uploadData,
        {
          method: 'POST',
          headers: {
            Authorization: `Token ${this.access_token}`,
          },
          // emulateJSON: true,
        })
        .then((response) => {
          if (response.status !== 200) {
            this.alertError.text = this.getErrorText(response);
            return response.status;
          }
          return axios.put(response.body.upload_url, data,
            {
              method: 'PUT',
              headers: axios.defaults.headers.common,
              // {
              //   'content-type': 'video/mp4',
              // },
              // emulateJSON: true,
            })
            .then((resp) => {
              if (response.status !== 200) {
                this.alertError.text = this.getErrorText(resp);
                return resp.status;
              }
              return response.body.final_url;
            })
            .catch((response) => {
              if (response.status === 401) {
                this.onLogout();
              }
              this.alertError.text = this.getErrorText(response);
              return response;
            });
        })
        .catch((response) => {
          if (response.status === 401) {
            this.onLogout();
          }
          this.alertError.text = this.getErrorText(response);
          return response;
        });
    },
    saveAuditItemVideo(item) {
      if (!item.video || item.selectedContent !== 'video') {
        return new Promise((resolve) => {
          resolve(false);
        });
      }
      return this.uploadVideo(item.video)
      .then((urlVideo) => {
        console.log('uploadUrlVideo', urlVideo);
        item.video_url = urlVideo;
        return null;
      });
    },
    // duplicateAudit() {
    //   this.$router.push({ name: this.$route.name.replace('Change', 'Duplicate') });
    //   location.reload();
    //   // this.$router.go(this.$router.currentRoute);
    // },
    duplicateAudit() {
      return this.$http.post(`audit-templates/${this.auditId}/duplicate/`, {},
        {
          method: 'POST',
          headers: {
            Authorization: `Token ${this.access_token}`,
          },
          // emulateJSON: true,
        })
        .then((response) => {
          if (response.status !== 200) {
            console.log('audit duplication err', response);
            this.alertError.text = this.getErrorText(response);
            return response.status;
          }
          console.log('DUPLICATE RESPONSE', response );
          this.$router.push({ name: 'Audit Configuration Change',
            params: { auditId: response.body.id } });
          return response.status;
        })
        .catch((response) => {
          if (response.status === 401) {
            this.onLogout();
          }
          this.alertError.text = this.getErrorText(response);
          return response;
        });
    },
    saveAudit() {
      const self = this;
      if (!this.validateAudit()) {
        this.alertError.visible = true;
        return;
      }
      this.hasSaveError = false;
      // return;
      this.upload.total = this.calculateImagesCount();
      this.upload.uploaded = 0;
      this.upload.image = (this.upload.total !== 0);
      this.upload.visible = true;

      this.sendSaveAuditTemplate(self.formData)
        .then((response) => {
          if (response !== 200 && response !== 201) {
            self.hasSaveError = true;
            console.log('sendSaveAuditTemplate err', response);
          } else
            this.needFill = false;
            if (self.duplicate) {
              setTimeout(() => {
                this.$router.push({
                  name: this.$route.name.replace('Duplicate', 'Change'),
                  params: {
                    companyId: this.$route.params.companyId,
                    checklistId: this.formData.id,
                  },
                });
              }, 3000);
            }
        })
        .then(() => self.saveTasks(self.formData.tasks))
        .then(() => {
          self.haveItemChanges = false;
          if (self.formData.tasks.length) {
            self.deleteTaskSteps(self.formData.tasks[self.activeTask]);
          }
        })
        .then(() => {
          if (self.hasSaveError) {
            console.log('saveEnd save has errors');
            // self.alertError.text = 'There were errors during the upload';
            self.alertError.visible = true;
            this.upload.visible = false;
          } else {
            console.log('saveEnd success');
            self.alertSuccess.visible = true;
            this.upload.visible = false;
            setTimeout(() => { self.$router.push({ name: 'Audits' }); }, 3000);
          }
        })
        .catch((response) => {
          console.log('ERRR have catch', response);
          // self.alertError.text = 'There were errors during the upload';
          self.alertError.text = self.getErrorText(response);
          self.alertError.visible = true;
          this.upload.visible = false;
        });
    },
    deleteAudit() {
      const self = this;
      if (this.formData.id) {
        this.sendDeleteAudit(this.formData.id)
          .then(() => {
            self.alertSuccess.text = 'Audit successfully deleted';
            self.alertSuccess.title = 'Well done!';
            self.alertSuccess.visible = true;
            setTimeout(() => { self.$router.push({ name: 'Audits' }); }, 3000);
          });
      }
    },
    sendDeleteAudit(id) {
      return this.$http.patch(`audit-templates/${id}/`, { is_active: false },
        {
          method: 'PATCH',
          headers: {
            Authorization: `Token ${this.access_token}`,
          },
        })
        .then((response) => {
          if (response.status !== 200) {
            console.log('audit del err', response);
            self.alertError.text = self.getErrorText(response);
            return response.status;
          }
          return response.status;
        })
        .catch((response) => {
          if (response.status === 401) {
            self.onLogout();
          }
          self.alertError.text = self.getErrorText(response);
          return response;
        });
    },
    deleteTask(task, index) {
      if (task.id) {
        this.sendDeleteTask(task);
      }
      this.formData.tasks.splice(index, 1);
      self.haveItemChanges = false;
    },
    sendDeleteTask(task) {
      return this.$http.patch(`audit-task-templates/${task.id}/`, { is_active: false },
        {
          method: 'PATCH',
          headers: {
            Authorization: `Token ${this.access_token}`,
          },
        })
        .then((response) => {
          if (response.status !== 200) {
            console.log('task del err', response);
            self.alertError.text = self.getErrorText(response);
            return response.status;
          }
          return response.status;
        })
        .catch((response) => {
          if (response.status === 401) {
            self.onLogout();
          }
          self.alertError.text = self.getErrorText(response);
          return response;
        });
    },
    saveTasks(tasks) {
      let count = 0;
      const self = this;
      function saveTask(task, resolve) {
        self.saveAuditItemVideo(task)
        .then(() => self.sendSaveTask(task))
          .then((response) => {
            if (response !== 201 && response !== 200) {
              console.log('sendSavetasks has err', response);
              self.hasSaveError = true;
            } else {
              return self.saveTaskSteps(task.steps, task.id);
            }
            return null;
          })
          .then(() => {
            count++;
            if (count === tasks.length) {
              self.sendUpdateAuditTasks(self.formData);
              resolve();
            }
          })
          .catch((response) => {
            self.alertError.text = self.getErrorText(response);
            self.hasSaveError = true;
            count++;
            if (count === tasks.length) {
              self.sendUpdateAuditTasks(self.formData);
              resolve();
            }
          });
      }
      return new Promise((resolve) => {
        if (!tasks.length) resolve();
        for (let i = 0; i < tasks.length; i++) {
          saveTask(tasks[i], resolve);
        }
      });
    },
    saveTask(task) {
      const self = this;
      if (!this.validateTask(task)) {
        this.alertError.visible = true;
        // this.alertError.text = 'Missing needed data.
        // All basic info fields and at least one audit question are mandatory.';
        this.activeTaskNext = null;
        return;
      }
      self.alertError.text = 'There were errors during the upload';
      self.hasSaveError = false;
      this.upload.total = task.steps.filter(item => item.picture).length;
      this.upload.total += task.description_file ? 1 : 0;
      this.upload.uploaded = 0;
      this.upload.image = (this.upload.total !== 0);
      this.upload.visible = true;
      self.saveAuditItemVideo(task)
      .then(() => self.sendSaveTask(task))
        .then((response) => {
          if (response !== 200 && response !== 201) {
            self.hasSaveError = true;
            self.alertError.text = self.getErrorText(response);
            console.log('saveTask err', response);
          } else {
            return self.saveTaskSteps(task.steps, task.id);
          }
          return null;
        })
        .then(() => self.deleteTaskSteps(task))
        .then(() => {
          if (self.hasSaveError) return null;
          return this.sendUpdateAuditTasks(self.formData);
        })
        .then(() => {
          if (self.hasSaveError) {
            console.log('saveEnd save has errors');

            self.alertError.visible = true;
            self.upload.visible = false;
            this.activeTaskNext = null;
          } else {
            console.log('saveEnd success');
            self.alertSuccess.visible = true;
            self.upload.visible = false;
            self.haveItemChanges = false;
            if (this.activeTaskNext !== null) {
              this.activeTask = this.activeTaskNext;
            }
          }
        })
        .catch((response) => {
          console.log('ERRR have catch', response);
          self.alertError.text = self.getErrorText(response);
          self.alertError.visible = true;
          self.upload.visible = false;
          this.activeTaskNext = null;
        });
    },
    saveTaskSteps(steps, taskId) {
      const self = this;
      if (!steps.length) {
        return null;
      }
      return new Promise((resolve) => {
        let count = 0;
        for (let i = 0; i < steps.length; i++) {
          self.saveAuditItemVideo(steps[i])
          .then(() => self.sendSaveStep(steps[i], taskId))
            .then((response) => {
              if (response !== 201 && response !== 200) {
                console.log('sendSaveStep has err', response);
                self.hasSaveError = true;
              }
              count++;
              if (count === steps.length) {
                resolve();
              }
            })
            .catch((response) => {
              self.alertError.text = self.getErrorText(response);
              return response;
            });
        }
      });
    },
    sendUpdateAuditPicture(audit) {
      if (!audit.id) return null;
      if (!audit.picture && audit.picture_url) return 200;
      const formData = new FormData();
      formData.append('picture', audit.picture);
      // Deprecated
      // if (this.duplicate) {
      //   if (audit.picture) {
      //     let blob = new Blob([audit.picture], { type: 'image/jpeg' });
      //     // let fileOfBlob = new File([blob], 'photo.jpg', { type: 'image/jpeg' });
      //     // form.append("upload", fileOfBlob);
      //     // formData.append('picture', fileOfBlob);
      //     formData.append('picture', blob, 'photo.jpg');
      //   }
      // } else {
      //   formData.append('picture', audit.picture);
      // }
      return this.$http.patch(`audit-templates/${audit.id}/`, formData,
        {
          method: 'PATCH',
          headers: {
            Authorization: `Token ${this.access_token}`,
          },
        })
        .then((response) => {
          if (response.status !== 200) {
            console.log('audit err', response);
            return response.status;
          }
          if (audit.picture) this.upload.uploaded++;
          return response.status;
        })
        .catch((response) => {
          if (response.status === 401) {
            this.onLogout();
          }
          this.alertError.text = this.getErrorText(response);
          return response;
        });
    },
    discardTaskChanges(taskIndex) {
      if (!this.formData.tasks[taskIndex].id) {
        Object.assign(this.formData.tasks[taskIndex], this.emptyTask);
        this.formData.tasks[taskIndex].steps = [];
        this.haveItemChanges = false;
        if (this.activeTaskNext !== null) {
          this.activeTask = this.activeTaskNext;
        }
        return;
      }
      for (let i = 0; i < this.audit.tasks.length; i++) {
        if (this.audit.tasks[i].id !== this.formData.tasks[taskIndex].id) {
          continue;
        }
        const task = this.formData.tasks[taskIndex];
        task.id = this.audit.tasks[i].id;
        task.name = this.audit.tasks[i].name;
        task.description = this.audit.tasks[i].description;
        task.description_file = '';
        task.description_file_url = this.audit.tasks[i].description_file;
        task.picture = '';
        task.picture_url = this.audit.tasks[i].picture;
        task.index = this.audit.tasks[i].index;
        task.weight = this.audit.tasks[i].weight;
        task.tags = this.audit.tasks[i].tags;
        task.tagsValue = JSON.parse(JSON.stringify(this.audit.tasks[i].tagsValue));
        task.steps = [];
        for (let j = 0; j < this.audit.tasks[i].steps.length; j++) {
          this.addEmptyStep(task);
          task.steps[j].id = this.audit.tasks[i].steps[j].id;
          task.steps[j].description = this.audit.tasks[i].steps[j].description;
          task.steps[j].order = this.audit.tasks[i].steps[j].index;
          task.steps[j].picture = '';
          task.steps[j].picture_url = this.audit.tasks[i].steps[j].picture;
        }
      }
      this.haveItemChanges = false;
      if (this.activeTaskNext !== null) {
        this.activeTask = this.activeTaskNext;
      }
    },
    getCompany() {
      this.$http.get('audit-report/82/?period=days&previous=13',
        {
          method: 'GET',
          headers: {
            Authorization: `Token ${this.access_token}`,
          },
        })
        .then((response) => {
          return response.status;
        })


      const assignDefaultRoles = () => {
        this.userRoles.push({
          name: 'Basic user',
          id: 'basic',
        });
        this.userRoles.push({
          name: 'Shift leader',
          id: 'shift_leader',
        });
        this.userRoles.push({
          name: 'Manager',
          id: 'manager',
        });
      }
      let id = null;
      if (this.authUser && this.authUser.company && this.authUser.company.id) {
        id = this.authUser.company.id;
      }
      if (this.$route.params.companyId) {
        id = this.$route.params.companyId;
      }
      if (!id) {
        assignDefaultRoles();
        return null;
      }
      return this.$http.get(`companies/${id}/`,
        {
          method: 'GET',
          headers: {
            Authorization: `Token ${this.access_token}`,
          },
        })
        .then((response) => {
          if (response.status !== 200) {
            assignDefaultRoles();
            return response.status;
          }
          this.userRoles = [];
          this.userRoles.push({
            name: response.body.basic_role_display_name || 'Basic user',
            id: 'basic',
          });
          this.userRoles.push({
            name: response.body.shift_leader_role_display_name || 'Shift leader',
            id: 'shift_leader',
          });
          this.userRoles.push({
            name: response.body.manager_role_display_name || 'Manager',
            id: 'manager',
          });
          return response.status;
        })
        .catch((response) => {
          if (response.status === 401) {
            this.onLogout();
          }
        });
    },
    sendUpdateAuditTasks(audit) {
      if (!audit.id) return null;
      const data = { tasks: [] };
      let index = 1;
      for (let i = 0; i < audit.tasks.length; i++) {
        if (audit.tasks[i].id) {
          data.tasks.push(audit.tasks[i].id);
          audit.tasks[i].index = index++;
        }
      }
      return this.$http.patch(`audit-templates/${audit.id}/`, data,
        {
          method: 'PATCH',
          headers: {
            Authorization: `Token ${this.access_token}`,
          },
        })
        .then((response) => {
          if (response.status !== 200) {
            console.log('audit err', response);
            return response.status;
          }
          return response.status;
        })
        .catch((response) => {
          if (response.status === 401) {
            this.onLogout();
          }
          this.alertError.text = this.getErrorText(response);
          return response;
        });
    },
    sendSaveAuditTemplate(audit) {
      const self = this;
      const data = {
        name: audit.name,
        area: (audit.area.length) ? audit.area[0].id : null,
        role: audit.role,
        score_type: audit.score_type,
        min_task_score: audit.lowScore,
        max_task_score: audit.highScore,
        // picture: audit.picture,
        tasks: [],
        double_signature_required: audit.signatureCount === 2,
        signature_required: audit.signatureCount > 0,
      };
      if (this.$route.params.companyId) {
        data.company = this.$route.params.companyId;
      }
      let index = 1;
      for (let i = 0; i < audit.tasks.length; i++) {
        if (audit.tasks[i].id) {
          data.tasks.push(audit.tasks[i].id);
          audit.tasks[i].index = index++;
        }
      }
      if (!audit.id) {
        return this.$http.post('audit-templates/', data,
          {
            method: 'POST',
            headers: {
              Authorization: `Token ${this.access_token}`,
            },
          })
          .then((response) => {
            if (response.status !== 201) {
              console.log('audit err', response);
              self.alertError.text = self.getErrorText(response);
              return response.status;
            }
            audit.id = response.body.id;
            return self.sendUpdateAuditPicture(audit);
          })
          .catch((response) => {
            if (response.status === 401) {
              self.onLogout();
            }
            self.alertError.text = self.getErrorText(response);
            return response;
          });
      }
      if (audit.picture_url && !audit.picture) delete data.picture;
      return this.$http.patch(`audit-templates/${audit.id}/`, data,
        {
          method: 'PATCH',
          headers: {
            Authorization: `Token ${this.access_token}`,
          },
        })
        .then((response) => {
          if (response.status !== 200) {
            console.log('audit err', response);
            self.alertError.text = self.getErrorText(response);
            return response.status;
          }
          return self.sendUpdateAuditPicture(audit);
        })
        .catch((response) => {
          if (response.status === 401) {
            self.onLogout();
          }
          self.alertError.text = self.getErrorText(response);
          return response;
        });
    },
    sendSaveTask(task) {
      const self = this;
      const data = {
        type: 'audit',
        name: task.name,
        description: task.description,
        description_file: task.description_file,
        picture: (task.selectedContent === 'image') ? task.picture : '',
        video: (task.selectedContent === 'video' && task.video_url) ? task.video_url : '',
        video_thumbnail: (task.selectedContent === 'video' && task.video_url) ? task.video_thumbnail : '',
        weight: task.weight,
        index: task.index,
        // tags: task.tags,
        tags: '',
      };
      for (let i = 0; i < task.tagsValue.length; i++) {
        if (i !== 0) {
          data.tags = `${data.tags}, `;
        }
        data.tags = `${data.tags}${task.tagsValue[i].name}`;
      }
      if (!data.weight && data.weight !== 0) {
        data.weight = 1;
      }
      if (this.$route.params.companyId) {
        data.company = this.$route.params.companyId;
      }
      if (!task.id) {
        const formData = new FormData();
        for (const key in data) {
          formData.append(key, data[key]);
        }
        return this.$http.post('audit-task-templates/', formData,
          {
            method: 'POST',
            headers: {
              Authorization: `Token ${this.access_token}`,
            },
          })
          .then((response) => {
            if (response.status !== 201) {
              console.log('task err', response);
              self.alertError.text = self.getErrorText(response);
              console.log(self.alertError.text);
              return response.status;
            }
            task.id = response.body.id;
            if (data.picture) this.upload.uploaded++;
            if (data.description_file) this.upload.uploaded++;
            return response.status;
          })
          .catch((response) => {
            if (response.status === 401) {
              self.onLogout();
            }
            self.alertError.text = self.getErrorText(response);
            return response;
          });
      }
      if (task.picture_url && !task.picture) delete data.picture;
      if (task.description_file_url && !task.description_file) delete data.description_file;
      const formData = new FormData();
      for (const key in data) {
        formData.append(key, data[key]);
      }
      return this.$http.patch(`audit-task-templates/${task.id}/`, formData,
        {
          method: 'PATCH',
          headers: {
            Authorization: `Token ${this.access_token}`,
          },
        })
        .then((response) => {
          if (response.status !== 200) {
            console.log('task err', response);
            self.alertError.text = self.getErrorText(response);
            console.log(self.alertError.text);
            return response.status;
          }
          if (data.picture) this.upload.uploaded++;
          if (data.description_file) this.upload.uploaded++;
          return response.status;
        })
        .catch((response) => {
          if (response.status === 401) {
            self.onLogout();
          }
          self.alertError.text = self.getErrorText(response);
          return response;
        });
    },
    sendSaveStep(step, taskId) {
      const data = {
        description: step.description,
        picture: (step.selectedContent === 'image') ? step.picture : '',
        video: (step.selectedContent === 'video' && step.video_url) ? step.video_url : '',
        video_thumbnail: (step.selectedContent === 'video' && step.video_url) ? step.video_thumbnail : '',
        index: step.order,
        template: taskId,
      };
      if (!step.id) {
        const formData = new FormData();
        for (const key in data) {
          formData.append(key, data[key]);
        }
        return this.$http.post('task-steps/', formData,
          {
            method: 'POST',
            headers: {
              Authorization: `Token ${this.access_token}`,
            },
            // emulateJSON: true,
          })
          .then((response) => {
            if (response.status !== 201) {
              console.log('task step err', response);
              self.alertError.text = self.getErrorText(response);
              return response.status;
            }
            step.id = response.body.id;
            if (data.picture) this.upload.uploaded++;
            return response.status;
          })
          .catch((response) => {
            if (response.status === 401) {
              self.onLogout();
            }
            self.alertError.text = self.getErrorText(response);
            return response;
          });
      }
      if (step.picture_url && !step.picture) delete data.picture;
      const formData = new FormData();
      for (const key in data) {
        formData.append(key, data[key]);
      }
      return this.$http.patch(`task-steps/${step.id}/`, formData,
        {
          method: 'PATCH',
          headers: {
            Authorization: `Token ${this.access_token}`,
          },
        })
        .then((response) => {
          if (response.status !== 200) {
            console.log('task step err', response);
            self.alertError.text = self.getErrorText(response);
            return response.status;
          }
          if (data.picture) this.upload.uploaded++;
          return response.status;
        })
        .catch((response) => {
          if (response.status === 401) {
            self.onLogout();
          }
          self.alertError.text = self.getErrorText(response);
          return response;
        });
    },
    deleteTaskSteps(task) {
      const self = this;
      return new Promise((resolve) => {
        if (!task.stepsMustDelete.length) return resolve();
        let count = 0;
        for (let i = 0; i < task.stepsMustDelete.length; i++) {
          self.sendDeleteTaskStep(task.stepsMustDelete[i])
            .then((response) => {
              if (response.status !== 200) {
                console.log('sendDeleteTaskStep has err', response);
                self.hasSaveError = true;
              }
              count++;
              if (count === task.stepsMustDelete.length) {
                task.stepsMustDelete = [];
                resolve();
              }
            });
        }
        return null;
      });
    },
    sendDeleteTaskStep(stepId) {
      return this.$http.patch(`task-steps/${stepId}/`, { is_active: false },
        {
          method: 'PATCH',
          headers: {
            Authorization: `Token ${this.access_token}`,
          },
          // emulateJSON: true,
        })
        .then((response) => {
          if (response.status !== 200) {
            console.log('DELETE step err ', response);
            return response;
          }
          return response;
        })
        .catch((response) => {
          if (response.status === 401) {
            self.onLogout();
          }
          self.alertError.text = self.getErrorText(response);
          return response;
        });
    },
    getTags() {
      let url = 'tags/';
      if (this.$route.params.companyId) {
        url = `${url}?company=${this.$route.params.companyId}`;
      }
      this.$http.get(url,
        {
          method: 'GET',
          headers: {
            Authorization: `Token ${this.access_token}`,
          },
          // emulateJSON: true,
        })
        .then((response) => {
          if (response.status !== 200) {
            console.log(response);
            // that.$set(that, 'moduleError', true);
            return;
          }
          response.body.forEach((tagItem) => {
            const tag = {
              name: tagItem.name,
              code: tagItem.name.substring(0, 2) + Math.floor((Math.random() * 10000000))
            };
            if (!this.tagsOptions.some(item => item.name === tag.name)) {
              this.tagsOptions.push(tag);
            }
          });
        })
        .catch((response) => {
          if (response.status === 401) {
            this.onLogout();
          }
        });
    },
    getAudit(id) {
      this.$http.get(`audit-templates/${id}/`,
        {
          method: 'GET',
          headers: {
            Authorization: `Token ${this.access_token}`,
          },
          // emulateJSON: true,
        })
        .then((response) => {
          if (response.status !== 200) {
            console.log(response);
            // that.$set(that, 'moduleError', true);
            return;
          }
          this.is_performed = response.body.is_performed;
          this.audit = response.body;
          this.fillAllData();
          this.processLoading = false;

          // return response;
        })
        .catch((response) => {
          if (response.status === 401) {
            this.onLogout();
          }
        });
    },
    getWorkingAreas() {
      let url = 'areas/?is_system=false';
      if (this.$route.params.companyId) {
        url = `${url}&company=${this.$route.params.companyId}`;
      }
      this.$http.get(url,
        {
          method: 'GET',
          headers: {
            Authorization: `Token ${this.access_token}`,
          },
          // emulateJSON: true,
        })
        .then((response) => {
          if (response.status !== 200) {
            console.log(response);
            // that.$set(that, 'moduleError', true);
            return;
          }
          this.areas = response.body;
          // return response;
        })
        .catch((response) => {
          if (response.status === 401) {
            this.onLogout();
          }
        });
    },
    getAreaById(id, area = this.areas) {
      for (let i = 0; i < area.length; i++) {
        if (area[i].id === id) {
          return area[i];
        }
        const res = this.getAreaById(id, area[i].subareas);
        if (res) {
          return res;
        }
      }
      return null;
    },
    downloadImage(url) {
      return axios.get(url, {
        headers: axios.defaults.headers.common,
        responseType: 'arraybuffer',
      })
      .then((resp) => {
        if (resp.status !== 200) {
          return null;
        }
        return resp.data;
      })
      .catch((response) => {
        console.log('download complite error', response);
        if (response.status === 401) {
          this.onLogout();
        }
        this.alertError.text = this.getErrorText(response);
        return null;
      });
    },
    fillAllData() {
      if (!this.audit && !this.duplicate) return;
      this.formData.id = this.auditId;
      // Deprecated
      // if (this.duplicate) this.formData.id = 0;
      this.formData.name = this.audit.name;
      this.formData.role = this.audit.role;
      this.formData.area = (this.audit.area && this.areas.length) ?
        [this.getAreaById(this.audit.area)] : [];
      this.formData.picture_url = this.audit.picture;
      // Deprecated
      // if (this.duplicate) {
      //   if (this.formData.picture_url) {
      //     this.downloadImage(this.formData.picture_url)
      //     .then((resp) => {
      //       if (resp) {
      //         this.formData.picture = resp;
      //       }
      //     })
      //     .catch((resp) => {
      //       console.log('err', resp);
      //     });
      //   }
      // }
      if (this.audit.signature_required) {
        this.formData.signatureCount = (this.audit.double_signature_required) ? 2 : 1;
      } else {
        this.formData.signatureCount = 0;
      }
      this.formData.score_type = this.audit.score_type;
      this.formData.lowScore = this.audit.min_task_score;
      this.formData.highScore = this.audit.max_task_score;
      this.formData.tasks = [];
      for (let i = 0; i < this.audit.tasks.length; i++) {
        // Deprecated
        // if (this.duplicate) continue;
        this.addEmptyTask();
        const task = this.formData.tasks[i];
        task.id = this.audit.tasks[i].id;
        task.name = this.audit.tasks[i].name;
        task.description = this.audit.tasks[i].description;
        task.description_file_url = this.audit.tasks[i].description_file;
        task.weight = this.audit.tasks[i].weight;
        task.picture_url = this.audit.tasks[i].picture;
        task.picture_url = this.audit.tasks[i].picture;
        task.thumbnail_url = (this.audit.tasks[i].video_thumbnail);
        task.video_url = (this.audit.tasks[i].video);
        if (task.picture_url) {
          task.selectedContent = 'image';
        }
        if (task.video_url) {
          task.picture_url = '';
          task.selectedContent = 'video';
        }
        task.index = this.audit.tasks[i].index;
        if (!this.audit.tasks[i].tags) this.audit.tasks[i].tags = '';
        task.tags = this.audit.tasks[i].tags;
        const tags = task.tags.split(', ');
        for (let tagIndex = 0; tagIndex < tags.length; tagIndex++) {
          if (tags[tagIndex]) {
            this.addTag(task, tags[tagIndex]);
          }
        }
        this.audit.tasks[i].tagsValue = JSON.parse(JSON.stringify(task.tagsValue));
        task.steps = [];
        for (let j = 0; j < this.audit.tasks[i].steps.length; j++) {
          this.addEmptyStep(task);
          task.steps[j].id = this.audit.tasks[i].steps[j].id;
          task.steps[j].description = this.audit.tasks[i].steps[j].description;
          task.steps[j].order = this.audit.tasks[i].steps[j].index;
          task.steps[j].picture_url = this.audit.tasks[i].steps[j].picture;
          task.steps[j].thumbnail_url = (this.audit.tasks[i].steps[j].video_thumbnail);
          task.steps[j].video_url = (this.audit.tasks[i].steps[j].video);
          if (task.steps[j].picture_url) {
            task.steps[j].selectedContent = 'image';
          }
          if (task.steps[j].video_url) {
            task.steps[j].picture_url = '';
            task.steps[j].selectedContent = 'video';
          }
        }
      }
      this.haveItemChanges = false;
    },
    validateSteps(task) {
      for (let i = 0; i < task.steps.length; i++) {
        task.steps[i].valid = true;
      }
      for (let i = 0; i < task.steps.length; i++) {
        if (task.steps[i].order <= 0) {
          task.steps[i].valid = false;
        }
        const currentOrder = task.steps[i].order;
        for (let j = i + 1; j < task.steps.length; j++) {
          if (+task.steps[j].order === currentOrder) {
            task.steps[i].valid = false;
            task.steps[j].valid = false;
          }
        }
      }
    },
    validateAudit() {
      this.alertError.title = 'Error!';
      this.alertError.text = 'Missing needed data. All basic info fields and at least one audit question are mandatory.';
      this.needFill = true;
      if (!this.formData.name) {
        this.alertError.text = 'Please fill field "Title"';
        this.alertError.visible = true;
        return false;
      }
      if (!this.formData.role) {
        this.alertError.text = 'Please select role';
        this.alertError.visible = true;
        return false;
      }
      if (!this.formData.area.length) {
        this.alertError.text = 'Please select working area';
        this.alertError.visible = true;
        return false;
      }
      let tasksIsValid = true;
      for (let i = 0; i < this.formData.tasks.length; i++) {
        tasksIsValid = tasksIsValid && this.validateTask(this.formData.tasks[i]);
      }
      return tasksIsValid;
    },
    validateTask(task) {
      if (!task.name) {
        this.alertError.text = 'Please fill audit item title';
        return false;
      }
      // if (!task.description) {
      //   this.alertError.text = 'Please fill audit item description';
      //   return false;
      // }
      task.video_require = false;
      if (task.selectedContent === 'video' &&
          ((task.video_thumbnail || task.thumbnail_url) &&
            !(task.video || task.video_url))) {
        task.video_require = true;
        this.alertError.text = 'Please add video file';
        this.alertError.visible = true;
        return false;
      }
      if (task.selectedContent === 'video' &&
          (!(task.video_thumbnail || task.thumbnail_url) &&
            (task.video || task.video_url))) {
        task.video_require = true;
        this.alertError.text = 'Please add thumbnail image';
        this.alertError.visible = true;
        return false;
      }
      if (!task.description_file) {
        for (let i = 0; i < task.steps.length; i++) {
          // if (!task.steps[i].description) {
          //   this.alertError.text = 'Please fill audit item step description';
          //   return false;
          // }
          if (!task.steps[i].valid) {
            this.alertError.text = 'Please correct instructions for the audit question';
            return false;
          }
        }
      }
      for (let i = 0; i < task.steps.length; i++) {
        const step = task.steps[i];
        step.video_require = false;
        if (step.selectedContent === 'video' &&
            ((step.video_thumbnail || step.thumbnail_url) &&
              !(step.video || step.video_url))) {
          step.video_require = true;
          this.alertError.text = 'Please add video file';
          this.alertError.visible = true;
          return false;
        }
        if (step.selectedContent === 'video' &&
            (!(step.video_thumbnail || step.thumbnail_url) &&
              (step.video || step.video_url))) {
          step.video_require = true;
          this.alertError.text = 'Please add thumbnail image';
          this.alertError.visible = true;
          return false;
        }
      }
      return true;
    },
    onScoreChange(e) {
      console.log(e.target.name);
      if (e.target.name === 'lowScore') {
        if ((!this.formData.lowScore && this.formData.lowScore !== 0) ||
          this.formData.lowScore < 0) {
          this.formData.lowScore = 0;
        }
        if (this.formData.lowScore > 9) {
          this.formData.lowScore = 9;
        }
        if (this.formData.lowScore >= this.formData.highScore) {
          this.formData.lowScore = this.formData.highScore - 1;
        }
        return;
      }
      if (!this.formData.highScore || this.formData.highScore > 10) {
        this.formData.highScore = 10;
      }
      if (this.formData.highScore < 1) {
        this.formData.highScore = 1;
      }
      if (this.formData.lowScore >= this.formData.highScore) {
        this.formData.highScore = this.formData.lowScore + 1;
      }
    },
    handleDragStart(e, item, index) {
      e.target.style.opacity = '0.4';
      e.dataTransfer.effectAllowed = 'move';
      e.dataTransfer.setData('text', index.toString());
      this.dragSrcEl = index;
    },
    handleDragEnd(e) {
      e.target.style.opacity = '';
    },
    handleDrop(e, index) {
      console.log('handleDrop()', index);
      if (e.stopPropagation) {
        e.stopPropagation(); // Stops some browsers from redirecting.
      }
      // Don't do anything if dropping the same column we're dragging.
      if (this.dragSrcEl !== index) {
        this.dragSrcEl = index;
        index = e.dataTransfer.getData('text');
        if (index < this.dragSrcEl) {
          this.formData.tasks.splice(+this.dragSrcEl + 1, 0, this.formData.tasks[index]);
          this.formData.tasks.splice(index, 1);
        } else {
          this.formData.tasks.splice(+this.dragSrcEl, 0, this.formData.tasks[index]);
          this.formData.tasks.splice(+index + 1, 1);
        }
        if (this.activeTask === +this.dragSrcEl) {
          if (this.haveItemChanges) {
            this.activeTask = +index;
            this.$refs.leavingItemConfirm.show();
          }
        } else {
          this.activeTask = +this.dragSrcEl;
        }
      }
      return false;
    },
    handleDragOver(e) {
      if (e.preventDefault) {
        e.preventDefault();
      }
      // console.log('handleDragOver()', index);
    },
    getErrorText(response) {
      console.log('getErrorText', response);
      const result = `There were errors during the upload (${response.status})`;
      if (response.status === 400) {
        if (!response.body) {
          return 'Large file';
        }
        for (const key in response.body) {
          return `${key}: ${response.body[key]}`;
        }
      }
      if (response.status === 401) {
        return 'Invalid authorization, please relogin';
      }
      if (response.status === 404) {
        return 'Not found (404)';
      }
      if (response.status === 500) {
        return 'Internal server error';
      }
      return result;
    },
    onChangeAuditTask() {
      this.haveItemChanges = true;
    },
  },
  computed: {},
  created() {
    // this.createUserRoles();
    this.getTags();
    this.getCompany();
    // this.addEmptyTask();
    this.getWorkingAreas();
    this.auditId = this.$route.params.auditId;
    if (this.auditId) {
      this.processLoading = true;
      this.getAudit(this.auditId);
    }
  },
  watch: {
    $route(to, from) {
      if (to.name === 'Audit Configuration Change' || to.name === 'Audit Configuration Change SuperUser') {
        this.processLoading = true;
        this.auditId = to.params.auditId;
        this.formData.id = to.params.auditId;
        this.getAudit(to.params.auditId);
      }
    },
    areas() {
      this.updateSuggestArea();
      if (this.audit) {
        this.formData.area = (this.audit.area && this.areas.length) ?
          [this.getAreaById(this.audit.area)] : [];
      }
    },
    activeTaskNext(val, prev) {
      if (val === null || val === this.activeTask) return;
      if (this.haveItemChanges && val !== null) {
        this.$refs.leavingItemConfirm.show();
      } else {
        this.activeTask = val;
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/auditConfig/auditConfig.component.js